import styled from 'styled-components'
import {Small} from '@modifi/ui'

export const SmallBlock = styled(Small)`
  display: block;
`
